export const isBrowser = typeof window !== 'undefined'

export const isNavigator = typeof navigator !== 'undefined'
